
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class DimensionSelect extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Boolean, default: false }) lightBtnShow!: boolean; //白底蓝字的
  @Prop({ type: Boolean, default: true }) cancelBtnShow!: boolean;
  @Prop({ type: Boolean, default: true }) okBtnShow!: boolean;
  @Prop({ type: String, default: "删除" }) title!: string; //标题
  @Prop({ type: String, default: "确认删除吗" }) showText!: string; //提示语
  @Prop({ type: String, default: "取消" }) cancelText!: string; //按钮文字
  @Prop({ type: String, default: "确认" }) okText!: string; //按钮文字
  @Prop({ type: Boolean, default: false }) showWarning!: false; //橙色叹号
  @Prop({ type: Boolean, default: false }) showError!: false; //红色叹号
  get showMe() {
    return this.show;
  }

  created() {
    //
  }
  cancel() {
    this.$emit("cancel");
  }
  ok() {
    this.$emit("ok");
    //
  }

  //关闭
  close() {
    this.$emit("cancel");
  }
}
